import { useTranslation } from "react-i18next";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { LocationCard } from "@/components/Cards";
import { CTAButtons } from "@/components/CTAButtons";
import { IndependenceStrip } from "@/components/IndependenceStrip";
import { LOCATIONS } from "@/data/site";

const Locations = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo
        title="English-Speaking Doctors Across Vietnam"
        description="Need a doctor in Vietnam? Doctors Vietnam helps travellers, expats and international patients find English-speaking doctors, clinics and hospitals across Ho Chi Minh City, Hanoi, Da Nang, Hoi An, Nha Trang, Vung Tau and Phu Quoc."
        path="/locations"
      />
      <PageHero
        eyebrow="Locations"
        title="English-speaking doctors across Vietnam"
        subtitle="We coordinate medical support in Vietnam's most-visited destinations. Find a doctor, clinic, hospital or nurse near where you're staying."
        crumbs={[{ label: t("nav.home"), to: "/" }, { label: t("nav.locations") }]}
      >
        <CTAButtons />
      </PageHero>

      <section className="vc-container py-14 sm:py-16">
        <h2 className="sr-only">Cities where Doctors Vietnam coordinates support</h2>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {LOCATIONS.map((l, i) => (
            <Reveal key={l.slug} delay={i * 0.05}>
              <LocationCard name={l.name} region={l.region} blurb={l.blurb} to={`/locations/${l.slug}`} />
            </Reveal>
          ))}
        </div>
        <p className="mt-5 text-sm text-[hsl(var(--vc-slate))]">* Service availability depends on location and provider confirmation.</p>
        <Reveal className="mt-8"><IndependenceStrip variant="band" /></Reveal>
      </section>
    </>
  );
};

export default Locations;
